import React from 'react';
import CardSelector, {
  CardOption,
} from '../../../components/molecules/CardSelector/CardSelector';
import styles from './SelectProcessType.module.scss';
import {
  useOrderFlowStore,
  ProductType,
} from '../../../store/orderFlowStore';
import { useTranslations } from '../../../hooks/useTranslations';
import { useOptionIcons } from '../../../hooks/useOptionIcons';

const SelectProcessType: React.FC = () => {
  const { productType, setProductType } = useOrderFlowStore();
  const t = useTranslations();
  const { getOptionIcon, isOptionIconsAvailable } = useOptionIcons();

  // オプションアイコンまたはプレビュー画像を取得
  const getImageUrl = (productTypeValue: string): string | undefined => {
    // まずオプションアイコンを試す
    if (isOptionIconsAvailable()) {
      const iconUrl = getOptionIcon('product', productTypeValue);
      if (iconUrl) return iconUrl;
    }
    
    // フォールバック：プレビュー画像を使用
    const previewImages = window.wakoFlowPreviewImages;
    if (!previewImages) return undefined;
    
    const productKey = `product_${productTypeValue.replace('-', '_')}`;
    return previewImages[productKey]?.url;
  };

  const processTypeOptions: CardOption[] = [
    {
      value: 'freeze-dried',
      label: t.selectProcessType_option1_label,
      priceInfo: '', // このステップでは価格情報は不要
      description: t.selectProcessType_option1_desc,
      image: getImageUrl('freeze-dried'),
    },
    {
      value: 'liquid-concentrate',
      label: t.selectProcessType_option2_label,
      priceInfo: '',
      description: t.selectProcessType_option2_desc,
      image: getImageUrl('liquid-concentrate'),
    },
    {
      value: 'straight-coffee',
      label: t.selectProcessType_option3_label,
      priceInfo: '',
      description: t.selectProcessType_option3_desc,
      image: getImageUrl('straight-coffee'),
    },
  ];

  return (
    <div className={styles.selectProcessTypeContainer}>
      <CardSelector
        title={t.selectProcessType_title}
        options={processTypeOptions}
        selectedValue={productType || ''}
        onChange={(value: string) => setProductType(value as ProductType)}
        showQuestionIcon={true}
        helpText={t.help_selectProcessType || ''}
      />
    </div>
  );
};

export default SelectProcessType; 